        <mat-card fxFlex="320px">
            <mat-card-header>
                <mat-card-title><h2 class="mat-h2">Login Little Bee <img *ngIf="loading === true" src="/wp-content/themes/swarm/app/assets/images/loading.gif" class="loader"></h2> </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <div fxLayout="column" >
                    <p class="form-error">
                        <mat-error *ngIf="error">{{error}}</mat-error>
                    </p>
                    <mat-form-field>
                        <input matInput placeholder="Username" required [formControl]="userLogin">
                        <mat-error *ngIf="userLogin.invalid">Required</mat-error>
                    </mat-form-field>
                    <mat-form-field>
                        <input matInput type="password" placeholder="Password" required [formControl]="userPassword">
                        <mat-error *ngIf="userPassword.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button class="button" type="submit" (click)="submitLogin()" (document:keyup.enter)="submitLogin()">LOGIN</button>
                <a href="/wp-login.php?action=lostpassword" class="button clear">RESET PASSWORD</a>
            </mat-card-actions>
        </mat-card>